import axiosInstance from "../../api/axiosInstance";

export const fetchRolesAPI = async () => {
  const rolesList = await axiosInstance.get("roles/get-all-roles");
  return rolesList.data;
};
